<div class="content-block dx-card">

  <dx-data-grid #grid
                [allowColumnReordering]="true"
                [columnAutoWidth]="true"
                [dataSource]="registration?.warehouseArticles ?? []"
                [wordWrapEnabled]="true"
                (onRowDblClick)="onRowDblClick($event)"
                (onInitNewRow)="onInitNewRow($event)"
                (onSelectionChanged)="selectedChanged($event)"
                (onEditorPreparing)="onEditorPreparing($event)">
    <dxo-selection mode="single"></dxo-selection>
    <dxo-grouping [autoExpandAll]="true"></dxo-grouping>

    <dxo-editing mode="popup">
      <dxo-popup title="Materiale" [showTitle]="true"></dxo-popup>
      <dxo-form [colCount]="2" [minColWidth]="0">
        <dxi-item dataField="materialCode" [colSpan]="2"></dxi-item>
        <dxi-item dataField="materialDescription" [colSpan]="2"></dxi-item>
        <dxi-item dataField="unityOfMeasurement"></dxi-item>
        <dxi-item dataField="quantity"></dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxo-search-panel [visible]="true"></dxo-search-panel>




    <dxi-column dataField="materialCode" caption="Codice" cellTemplate="codiceCellTemplate" [setCellValue]="codiceSetCellValue">
      <dxo-lookup [dataSource]="materialsLookupDataSource" valueExpr="materialCode" displayExpr="materialDescription"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="quantity" caption="Qtà" cssClass="cell-quantita" dataType="number" [width]="100">
      <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
    </dxi-column>

    <dxi-column dataField="materialDescription" dataType="string" [visible]="false" [allowEditing]="true"></dxi-column>


    <dxi-column dataField="unityOfMeasurement" caption="Unita Misura" [visible]="false">
      <dxo-lookup [dataSource]="getUnitaOptions" valueExpr="this" displayExpr="this"></dxo-lookup>
    </dxi-column>


    <div *dxTemplate="let d of 'codiceCellTemplate'">
      <div class="testo-formattato">
        <p class="rigaCodice">{{d.data.materialCode}}</p>
        <p class="rigaDescrizione">{{d.data.materialDescription}}</p>
        <p class="rigaUm">{{d.data.unityOfMeasurement}}</p>
      </div>
    </div>
  </dx-data-grid>
</div>

<dx-speed-dial-action icon="add" label="Aggiungi" [index]="1" (onClick)="addRow()"></dx-speed-dial-action>
<dx-speed-dial-action icon="trash" label="Cancella" [index]="2" [visible]="selectedRowIndex !== -1" (onClick)="deleteRow()"></dx-speed-dial-action>
<dx-speed-dial-action icon="edit" label="Modifica" [index]="3" [visible]="selectedRowIndex !== -1" (onClick)="editRow()"></dx-speed-dial-action>
